module.exports = __webpack_public_path__ + "static/media/vampiress_crown.a9939e43.png";